/**
 * TrialBenefits - Checkmark list of trial/membership benefits
 *
 * Shows reassurance messages like "No charge until day 8"
 */

interface TrialBenefitsProps {
  /** Whether to show trial-specific messaging */
  isTrial?: boolean;
  /** Custom benefits to display (overrides defaults) */
  benefits?: string[];
}

const DEFAULT_TRIAL_BENEFITS = [
  'No charge for 7 days',
  'Cancel anytime',
];

const DEFAULT_MEMBERSHIP_BENEFITS = [
  'Cancel anytime',
  'Secure payment',
];

export function TrialBenefits({ isTrial = true, benefits }: TrialBenefitsProps) {
  const displayBenefits =
    benefits || (isTrial ? DEFAULT_TRIAL_BENEFITS : DEFAULT_MEMBERSHIP_BENEFITS);

  return (
    <div className="flex flex-col items-center gap-2">
      {displayBenefits.map((benefit, index) => (
        <div key={index} className="flex items-center gap-2">
          <img
            src="/images/icons/payment-page-v2/icon-checkmark.svg"
            alt=""
            className="h-4 w-4 flex-shrink-0"
          />
          <span className="text-sm text-catch-dark-blue-90">{benefit}</span>
        </div>
      ))}
    </div>
  );
}

export default TrialBenefits;
